module.exports = __webpack_public_path__ + "static/img/1_2_1.53cffad6.jpg";